import React, { useState, useEffect } from "react";
import allMetrics from "data/allMetrics.js";
import DashboardBuilderSection from "client_config/DashboardBuilderSection";
import { DragDropContext, Droppable } from "react-beautiful-dnd";
import jsDig from "utils/jsDig.js";
import { camelCase, snakeCase, capitalize } from "lodash";

const allMetricData = allMetrics();
const icons = {
  search: require("images/icons/Search-Icon.png"),
  social: require("images/icons/Social-Icon.png"),
  display: require("images/icons/Display-Icon.png"),
  video: require("images/icons/Video-Icon.png"),
};

export default function DashboardBuilder(props) {
  const sectionList = jsDig(["metricsByDashboard", props.service, "sections"], allMetricData);
  const metricList = jsDig(["metricsByDashboard", props.service, "metrics"], allMetricData);
  const dashboardId = jsDig(["id"], props.dashboard) ? jsDig(["id"], props.dashboard) : 0;
  const [dashboardOrder, setDashboardOrder] = useState(jsDig(["dashboardOrder"], props.dashboard) ? jsDig(["dashboardOrder"], props.dashboard) : []);
  const defaultSectionOrder = dashboardOrder.length > 0 ? dashboardOrder.map((section) => section.name) : Object.keys(sectionList);
  const [dashboards, setDashboards] = useState(props.dashboards);
  const [sectionOrder, setSectionOrder] = useState(defaultSectionOrder);
  const onDragEnd = (result) => {
    const { destination, source, draggableId } = result;
    if (!destination) {
      return;
    }
    if (destination.droppableId === source.droppableId && destination.index === source.index) {
      return;
    }

    let newOrder = [...sectionOrder];
    newOrder.splice(source.index, 1);
    newOrder.splice(destination.index, 0, draggableId);
    let newDashboardOrder = dashboardOrder;
    newDashboardOrder.sort((a, b) => {
      if (newOrder.indexOf(a.name) > newOrder.indexOf(b.name)) {
        return 1;
      } else return -1;
    });
    newDashboardOrder = newDashboardOrder.map((el, index) => {
      el.order = index;
      return el;
    });

    setSectionOrder(newOrder);
    if (props.onboarding && props.setDashboard) {
      let newDashboard = dashboards;
      newDashboard[props.currentDashboard].dashboardOrder = newDashboardOrder;
      props.setDashboard([...newDashboard]);
    }
  };
  useEffect(() => {
    setDashboards([...props.dashboards]);
    setDashboardOrder(jsDig(["dashboardOrder"], props.dashboard) ? jsDig(["dashboardOrder"], props.dashboard) : []);
  }, [props.dashboards]);

  return (
    <>
      <DragDropContext onDragEnd={onDragEnd}>
        <Droppable droppableId="dashboard-builder-droppable">
          {(provided) => (
            <div className="dashboard-builder" {...provided.droppableProps} ref={provided.innerRef}>
              {sectionOrder.map((sectionName, index) => {
                let sectionData = jsDig([`${sectionName}`], sectionList);
                let metricData = jsDig([sectionName], metricList);
                let configData = dashboardOrder.find((section) => section.name == sectionName);
                let defaultMetrics = jsDig(["metricsByDashboard", props.service, "defaults", props.accountType, sectionName], allMetricData);
                // We can't store campaign group information in allMetrics.js because they are dynamic, we need to get them from props
                if (props.service == "ppc" && sectionName == "campaignGroups" && props.campaignGroups) {
                  metricData = {};
                  Object.keys(props.campaignGroups).forEach((subservice) => {
                    props.campaignGroups[subservice].forEach((campaignGroup) => {
                      const icon = `/datapulse${icons[subservice]}`;
                      const campaignGroupName = jsDig(["name"], campaignGroup);
                      if (campaignGroupName) {
                        metricData[camelCase(campaignGroupName)] = {
                          icon: icon,
                          name: { shortened: campaignGroupName, title: campaignGroupName, snakeCase: snakeCase(campaignGroupName) },
                        };
                      }
                    });
                  });
                }
                if (props.service == "ppc" && sectionName == "performanceByChannel" && props.performanceByChannel) {
                  metricData = {};
                  Object.keys(props.performanceByChannel).forEach((subservice) => {
                    if (props.performanceByChannel[subservice]) {
                      const icon = `/datapulse${icons[subservice]}`;
                      metricData[subservice] = {
                        icon: icon,
                        name: { shortened: capitalize(subservice), title: capitalize(subservice), snakeCase: subservice },
                      };
                    }
                  });
                }
                return (
                  <DashboardBuilderSection
                    key={sectionName}
                    index={index}
                    service={props.service}
                    dashboardId={dashboardId}
                    defaultMetrics={defaultMetrics ? defaultMetrics : {}}
                    configData={configData}
                    sectionName={sectionName}
                    sectionData={sectionData}
                    metricData={metricData}
                    onboarding={props.onboarding}
                    dashboards={dashboards}
                    setDashboard={props.setDashboard}
                    currentDashboard={props.currentDashboard}
                    searchSection={props.searchSection}
                    ppcSection={props.ppcSection}
                    socialSection={props.socialSection}
                    videoSection={props.videoSection}
                    displaySection={props.displaySection}
                    seoSection={props.seoSection}
                    enabledServices={props.enabledServices}
                    subServiceDashboards={props.subServiceDashboards}
                  />
                );
              })}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>
    </>
  );
}
